import Molde from "./MoldeTourTradicional";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function ValleVip() {
  return (
    <>
      <Molde
        image={"/images/valle-vip-portada.png"}
        title={"VALLE VIP"}
        subtitle={"(FULL DAY)"}
        description={
          "El tour del Valle VIP es uno de los tours más populares de la región. El Valle Sagrado de los Incas fue un área crucial para el imperio Inca y funcionó como un centro agrícola, espiritual y político para ellos. A lo largo de su recorrido, se pueden encontrar muchos sitios incas y preincas y el recorrido del Valle Sagrado, visitaremos los principales sitios arqueologicos como, Chincheros, chinchero, las salineras de Maras, Ollantaytambo, Urubamba y Pisac. Con una duración de un día completo, podrá apreciar los finos trabajos de artesanía que produjeron los incas y ver el hermoso paisaje del Valle Sagrado. Muchos turistas optan por hacer este recorrido justo antes de su visita a Machu Picchu"
        }
        linkForm={"/reservar/citytour-dia"}
        tipoprecio={"Precio por persona"}
        monto={"US$ 35.00"}
        moneda={"DOLARES"}
        
        picture1={            
          <>
            <div>
              <CardItinerario
                num="01"
                title="INICIO"
                lugar="CHINCHEROS"
              ></CardItinerario>      
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/chinchero_1.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/chinchero_2.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/chinchero_3.png`} alt="" />
                </div>
            </div>
          </>
        }

        picture2={            
          <>
            <div>
              <CardItinerario
                num="02"
                title="PARADA"
                lugar="MORAY"
              ></CardItinerario>      
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/moray_1.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/moray_2.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/moray_3.png`} alt="" />
                </div>
            </div>
          </>
        }

        picture3={            
          <>
            <div>
              <CardItinerario
                num="03"
                title="PARADA"
                lugar="MORAY"
              ></CardItinerario>      
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salineras_1.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salineras_2.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/salineras_3.png`} alt="" />
                </div>
            </div>
          </>
        }

        picture4={            
          <>
            <div>
              <CardItinerario
                num="04"
                title="PARADA"
                lugar="OLLANTAYTAMBO"
              ></CardItinerario>      
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ollanta_1.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ollanta_2.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ollanta_3.png`} alt="" />
                </div>
            </div>
          </>
        }

        picture5={            
          <>
            <div>
              <CardItinerario
                num="04"
                title="PARADA"
                lugar="PISAC"
              ></CardItinerario>      
                <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/pisac_1.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/pisac_2.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/pisac_3.png`} alt="" />
                </div>
            </div>
          </>
        }

        
        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            <p className="text-primary-800 font-light">Guia profesional</p>
            <p className="text-primary-800 font-light">Asistencia permanente</p>
            <p className="text-primary-800 font-light">Almuerzo</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Boleto turistico</p>
            <p className="text-primary-800 font-light">Ingreso a las salineras</p>
            <p className="text-primary-800 font-light">Gastos extra</p>
            <p className="text-primary-800 font-light">Desayuno</p>
            <p className="text-primary-800 font-light">Cena</p>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Facil"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"Full day"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Cultural - trek"}
              />
            </>
          }

        lugarvisita={
                  <>
                    <CardLugar
                      icon={"01"}
                      title={"Chincheros"}
                    />
                    <CardLugar
                      icon={"02"}
                      title={"chinchero"}
                    />
                    <CardLugar
                      icon={"03"}
                      title={"Salineras"}
                    />
                    <CardLugar
                      icon={"04"}
                      title={"Ollantaytambo"}
                    />
                    <CardLugar
                      icon={"05"}
                      title={"Urubamba"}
                    />
                    <CardLugar
                      icon={"06"}
                      title={"Pisac"}
                    />
                    
                  </>
                }

        TourRecomienda={
          <>
            <CardRecomienda
              img={"/images/montania_colores.png"}
              title={"MONTAÑA 7 COLORES"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/montania-colores'}
            />
            <CardRecomienda
              img={"/images/valle-vip-5.png"}
              title={"VALLE VIP"}
              puntuacion={"5"}
              link={'/tour-tradicional/valle-vip'}
            />
            <CardRecomienda
              img={"/images/laguna_huamantay.png"}
              title={"LAGUNA HUAMANTAY"}
              puntuacion={"5"}
              link={'/tour-tradicional/laguna-huamantay'}
            />
            <CardRecomienda
              img={"/images/maras-moray-4.png"}
              title={"MARAS-MORAY"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/maras-moray'}
            />
          </>
        }
      />
    </>
  );
}
